import type { Settlement } from '../types';

export function syncPopulation(settlement: Settlement): void {
    settlement.population = settlement.people.length;
}
